import React, { useEffect, useState } from "react";
import { Shell, KpiCard, Section, StatusPill } from "@/components/loomi/Layout";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { LayoutDashboard, History, UserCircle, Sparkles, Gift } from "lucide-react";

export const PANEL_NAV = [
  { to: "/panel", label: "Available surveys", icon: LayoutDashboard, testId: "nav-panel-surveys" },
  { to: "/panel/rewards", label: "Rewards", icon: Gift, testId: "nav-panel-rewards" },
  { to: "/panel/history", label: "History", icon: History, testId: "nav-panel-history" },
  { to: "/panel/profile", label: "Profile", icon: UserCircle, testId: "nav-panel-profile" },
];

export default function PanelDashboard() {
  const [me, setMe] = useState(null);
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    (async () => {
      const [mR, pR] = await Promise.all([api.get("/panel/me"), api.get("/projects")]);
      setMe(mR.data); setProjects(pR.data);
    })();
  }, []);

  const join = async (pid) => {
    try {
      const { data } = await api.post(`/panel/join/${pid}`);
      toast.success("Redirecting to survey…");
      window.location.href = data.entry_url;
    } catch (e) { toast.error("Couldn't join", { description: formatApiError(e) }); }
  };

  return (
    <Shell title="Your surveys" portalLabel="Panel" nav={PANEL_NAV}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <KpiCard label="Points balance" value={me?.points_balance ?? "—"} accent="green" testId="panel-kpi-points" />
        <KpiCard label="Available" value={projects.length} accent="primary" testId="panel-kpi-available" />
        <KpiCard label="Country" value={me?.profile?.country || "—"} accent="blue" testId="panel-kpi-country" />
      </div>

      <div className="mt-8">
        <Section title="Available surveys" testId="section-available">
          {projects.length === 0 ? (
            <div className="text-mute text-sm py-8 text-center" data-testid="panel-empty">No surveys available right now. Check back soon!</div>
          ) : (
            <div className="grid md:grid-cols-2 gap-4">
              {projects.map((p) => (
                <div key={p.id} className="glass rounded-xl p-5 border border-white/10 hover:border-white/20 transition-colors" data-testid={`panel-survey-${p.id}`}>
                  <div className="flex items-start justify-between mb-2">
                    <div className="text-xs uppercase tracking-widest text-mute">{p.type}</div>
                    <StatusPill status={p.status} />
                  </div>
                  <h3 className="font-display font-bold text-lg leading-snug mb-2">{p.name}</h3>
                  <div className="flex items-center gap-4 text-xs text-mute mb-4">
                    <span className="inline-flex items-center gap-1"><Sparkles className="w-3.5 h-3.5" /> {p.loi} min</span>
                    <span className="inline-flex items-center gap-1 status-complete font-medium"><Gift className="w-3.5 h-3.5" /> {p.reward_points} pts</span>
                  </div>
                  <button onClick={() => join(p.id)} data-testid={`panel-start-${p.id}`} className="w-full bg-indigo-500 hover:bg-indigo-400 rounded-md py-2 text-sm font-medium">
                    Start survey →
                  </button>
                </div>
              ))}
            </div>
          )}
        </Section>
      </div>
    </Shell>
  );
}
